export function usesNewsTypeColors(type?: string): boolean {
  return type === 'Nieuws' || type === 'Pers';
}
